import React from "react";

export default function useQuery(): URLSearchParams {
    const { search } = window.location;

    return React.useMemo(() => new URLSearchParams(search), [search]);
}
